<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Purchase Invoices</h4>
                <p class="text-subtitle-1">List of purchase invoices</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3" v-if="hasPermission(perm.invoice.create)">
                <v-btn block color="primary" @click="handleNew">
                    <v-icon left>mdi-plus</v-icon>
                    new invoice
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu offset-y :close-on-content-click="false" min-width="300">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            block
                            v-bind="attrs"
                            v-on="on"
                            depressed
                            >
                            <v-icon left>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </template>
                    <v-card 
                        flat
                        >
                        <v-card-title>Search</v-card-title>
                        <v-card-text>
                            <PurchaseInvoiceListSearch ref="form"/>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn  color="primary" block @click="$refs.form.submit()">Submit</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <PurchaseInvoiceList/>
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
import permissions from './../../data/permissions';
import PurchaseInvoiceList from "./../../components/purchase/PurchaseInvoiceList"
import PurchaseInvoiceListSearch from "./../../components/purchase/PurchaseInvoiceListSearch"
import { mapGetters } from 'vuex';

export default {
    name : "PurchaseInvoiceListView",
    components: {
        PurchaseInvoiceList,
        PurchaseInvoiceListSearch
    },
    data() {
        return {
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        handleNew() {
            this.$router.push({ name: "PurchaseInvoiceCreate"})
        }
    }
}
</script>

<style>

</style>